import { fetchCheckout, fetchData } from '../utils/async';
import { deepClone } from '../utils/object';
import { prefix, fieldValidation, restrictToLatinCharSet } from '../utils/string';
import { shippingMethods } from '../config';

export const SUBSCRIBED = 'SUBSCRIBED';
export const RECENTLY_VIEWED = 'RECENTLY_VIEWED';
export const LIST_ITEM_CACHE = 'LIST_ITEM_CACHE';
export const ADD_VOUCHER = 'ADD_VOUCHER';
export const VOUCHER_INPUT = 'VOUCHER_INPUT';
export const VOUCHER_ERROR = 'VOUCHER_ERROR';
export const ADD_TO_BAG_ERROR = 'ADD_TO_BAG_ERROR';
export const SELECT_SIZE = 'SELECT_SIZE';
export const SELECT_QUANTITY = 'SELECT_QUANTITY';
export const UPDATE_SELECTION_CACHE = 'UPDATE_SELECTION_CACHE';
export const UPDATE_SELECTION = 'UPDATE_SELECTION';
export const UPDATE_ADDITIONAL_INFORMATION = 'UPDATE_ADDITIONAL_INFORMATION';
export const UPDATE_AIRMEE = 'UPDATE_AIRMEE';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const UPDATE_ERRORS = 'UPDATE_ERRORS';
export const DELIVERY_PROCEED = 'DELIVERY_PROCEED';
export const KLARNA_LOADED = 'KLARNA_LOADED';
export const KLARNA_UNLOADED = 'KLARNA_UNLOADED';
export const SELECTION_ERROR = 'SELECTION_ERROR';
export const SELECTION_ERROR_STOCK = 'SELECTION_ERROR_STOCK';
export const ENRICH_PRODUCTS = 'ENRICH_PRODUCTS';
export const INITIATED_SCRIPT = 'INITIATED_SCRIPT';
export const BOOLEAN_CHANGE = 'BOOLEAN_CHANGE';
export const PAYMENT_RETURN = 'PAYMENT_RETURN';
export const DESTROY_SELECTION = 'DESTROY_SELECTION';

export const clientInit = () => ({ type: 'CLIENT_INIT' });
export const retrieveProductCache = () => ({ type: 'RETRIEVE_PRODUCT_CACHE' });

export const subscribeToNewsletter = (email) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;

	return fetchCheckout(`/newsletter-subscription/${email}`, token, [], 'POST').then(() => (
		dispatch({ type: SUBSCRIBED })
	)).catch((err) => console.log('DEBUG: error when subscribing to newsletter ', err));
};

export const selectSize = (product, item, quantity = 1) => ({ type: SELECT_SIZE, product, item, quantity });

export const addRecentlyViewed = (product) => ({ type: RECENTLY_VIEWED, product });

export const listItemCache = (productId, listName) => ({ type: LIST_ITEM_CACHE, productId, listName });

export const addToBag = (item, quantity = 1, category, cachedItem, note = false) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	const product = item.slice(0, item.indexOf('-'));
	const cache = deepClone(cachedItem);
	cache.category = category;

	return (
		fetchCheckout(`/items/${item}/quantity/${quantity}`, token, [], 'POST').then((data) => {
			if (data.errors) return dispatch({ type: ADD_TO_BAG_ERROR });

			dispatch({ type: UPDATE_SELECTION_CACHE, product, productCache: cache });
			if (note) dispatch({ type: UPDATE_ADDITIONAL_INFORMATION, note });

			dispatch({ type: UPDATE_SELECTION, data });

			return data;
		}).then((data) => {
			setTimeout(() => {
				if (getState().environment.properties.openCart === 1) dispatch({ type: 'OPEN_CART' });
			}, 3000);
			setTimeout(() => {
				if (getState().environment.properties.openCart === 2) dispatch({ type: 'OPEN_CART' });
			}, 3300);

			dispatch({ type: 'OPEN_CART' });

			return data;
		}).catch((err) => console.log('DEBUG: err', err))
	);
};

export const changeQuantity = ({ item, line }, quantity) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	const personalizedItems = getState().checkout.payment.additionalInformation;
	const product = item.slice(0, item.indexOf('-'));
	const allItems = getState().checkout.selection.items;
	// Get all items sharing the same product id before removing the product from cache.
	const totalProducts = allItems.reduce((acc, selectionItem) => (selectionItem.item.indexOf(product) === 0 ? acc + 1 : acc), 0);

	return (
		fetchCheckout(`/lines/${line}/quantity/${quantity}`, token, [], 'PUT').then((data) => {
			const personalizedItem = personalizedItems.filter((pI) => pI.item === item)[0];
			if (personalizedItem) {
				// There is personalization attached to this item run changeQuantity to match.
				const personalizedSelectionItem = allItems.filter((aI) => aI.item === personalizedItem.details.giftWrap)[0];
				if (!personalizedSelectionItem) dispatch({ type: UPDATE_ADDITIONAL_INFORMATION, note: { item, message: '' } });
				else {
					if (quantity === 0) {
						dispatch({ type: UPDATE_ADDITIONAL_INFORMATION, note: { item, message: '' } });
					}
					dispatch(changeQuantity(personalizedSelectionItem, quantity));
				}
			}

			if (quantity === 0 && totalProducts <= 1) {
				// Only one item left before updating selection.
				dispatch({ type: UPDATE_SELECTION_CACHE, product });
			}

			dispatch({ type: UPDATE_SELECTION, data });

			return data;
		}).catch((err) => console.log('DEBUG: err', err))
	);
};

export const changeSize = (product, line, quantity, newItem) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;

	// Remove previous product
	return fetchCheckout(`/lines/${line}/quantity/0`, token, [], 'PUT').then(() => (
		fetchCheckout(`/items/${newItem}/quantity/${quantity}`, token, [], 'POST')
	)).then((data) => (
		dispatch({ type: UPDATE_SELECTION, data })
	)).catch((err) => console.log('DEBUG: err', err));
};

export const changeCountry = (country) => (dispatch, getState) => {
	const newCountry = getState().environment.setup.countries[country];
	const market = getState().environment.campaign ? getState().environment.campaign.market : newCountry.market;
	const token = getState().checkout.selection.token;
	dispatch({ type: 'UPDATE_COUNTRY', country: newCountry.country, market, pricelist: newCountry.pricelist });
	dispatch({ type: 'RETRIEVE_PRODUCT_CACHE' });
	return (
		fetchCheckout(`/countries/${newCountry.country}`, token, [], 'PUT').then((data) => (
			dispatch({ type: UPDATE_SELECTION, data })
		)).catch((err) => console.log('DEBUG: err', err))
	);
};

export const changePaymentMethod = (method) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	return (
		fetchCheckout(`/payment-methods/${method}`, token, [], 'PUT').then((data) => (
			dispatch({ type: UPDATE_SELECTION, data })
		)).catch((err) => console.log('DEBUG: err', err))
	);
};

export const changeShippingMethod = (method) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	return (
		fetchCheckout(`/shipping-methods/${method}`, token, [], 'PUT').then((data) => (
			dispatch({ type: UPDATE_SELECTION, data })
		)).catch((err) => console.log('DEBUG: err', err))
	);
};

export const checkProceed = () => (dispatch, getState) => {
	const { selection, payment } = getState().checkout;
	const { zipCode = '', country, email } = payment.address;
	const hasAirmee = selection.shippingMethods ? selection.shippingMethods.reduce((acc, method) => (method.shippingMethod === shippingMethods.airmee ? { ...acc, [method.shippingMethod]: method } : acc), {}) : false;

	let error = false;
	if (fieldValidation(email, 'email')) {
		error = true;
		dispatch({ type: UPDATE_ERRORS, group: 'address', id: 'email', error });
	}

	if (!payment.termsAndConditions) {
		error = true;
		dispatch({ type: UPDATE_ERRORS, id: 'termsAndConditions', error });
	}

	if (fieldValidation(zipCode) && Object.keys(hasAirmee).length > 0) {
		error = true;
		dispatch({ type: UPDATE_ERRORS, group: 'address', id: 'zipCode', error });
	}

	if (!fieldValidation(zipCode) && Object.keys(hasAirmee).length > 0) {
		fetchData('airmee', { country, zipCode }).then(({ success, errors = false }) => {
			if (!success && selection.shippingMethod && selection.shippingMethod.toLowerCase().indexOf('airmee') !== -1) {
				const otherShippingMethods = selection.shippingMethods.filter((method) => method.shippingMethod.toLowerCase().indexOf('airmee') === -1);
				if (otherShippingMethods.length > 0) dispatch(changeShippingMethod(otherShippingMethods[0].shippingMethod));
			}
			if (!error) {
				dispatch({ type: DELIVERY_PROCEED });
			}
			dispatch({ type: UPDATE_AIRMEE, success, errors });
			return dispatch(updateKlarna());
		}).catch((err) => console.log(err));
	} else if (!error) {
		dispatch({ type: DELIVERY_PROCEED });
		return dispatch(updateKlarna(true));
	}
};

export const changeAddressInput = (group, id, value) => ({ type: UPDATE_ADDRESS, group, id, value: restrictToLatinCharSet(value) });

export const checkAddressInputErrors = (group, id, value) => {
	const fieldType = id === 'email' ? 'email' : 'text';
	const error = fieldValidation(value, fieldType);

	return ({ type: UPDATE_ERRORS, group, id, error });
};

export const booleanChange = (id) => ({ type: BOOLEAN_CHANGE, id });

export const addVoucher = () => (dispatch, getState) => {
	const currentValue = getState().checkout.vouchers.currentValue;
	const token = getState().checkout.selection.token;

	if (fieldValidation(currentValue)) return dispatch({ type: VOUCHER_ERROR });

	return fetchCheckout('/vouchers', token, { voucher: currentValue }, 'POST').then((data) => {
		if (data.errors) return dispatch({ type: VOUCHER_ERROR });

		dispatch({ type: VOUCHER_INPUT, value: '' });
		return dispatch({ type: UPDATE_SELECTION, data });
	}).catch((err) => console.log('DEBUG: err', err));
};

export const removeVoucher = (voucherId) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	return fetchCheckout(`/vouchers/${voucherId}`, token, {}, 'DELETE').then((data) => (
		dispatch({ type: UPDATE_SELECTION, data })
	)).catch((err) => console.log('DEBUG: err', err));
};

export const voucherInputChange = (value) => ({ type: VOUCHER_INPUT, value });

export const initiatedScript = () => ({ type: INITIATED_SCRIPT });

export const initiateKlarna = () => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	const { setup } = getState().environment;
	const paymentData = {};
	paymentData.paymentFailedPage = `${window.location.origin}${prefix(setup, 'selection/failed')}`;
	paymentData.paymentReturnPage = `${window.location.origin}${prefix(setup, 'selection/receipt')}`;

	return fetchCheckout('/payment', token, paymentData, 'POST').then((data) => (
		dispatch({ type: 'INITIATE_SELECTION', data })
	)).catch((err) => console.log('DEBUG: err', err));
};

export const klarnaLoaded = () => ({ type: KLARNA_LOADED });

export const klarnaUnloaded = () => ({ type: KLARNA_UNLOADED });

export const updateKlarna = (cartAbandonmentEmail = false) => (dispatch, getState) => {
	const token = getState().checkout.selection.token;
	const { setup } = getState().environment;
	const { country, countries } = setup;
	let paymentData = deepClone(getState().checkout.payment);
	const useShippingAddress = getState().checkout.useShippingAddress;
	if (useShippingAddress) paymentData.shippingAddress.country = country;
	paymentData.address.country = paymentData.address.country || country;
	paymentData.paymentFailedPage = `${window.location.origin}${prefix(setup, 'selection/failed')}`;
	paymentData.paymentReturnPage = `${window.location.origin}${prefix(setup, 'selection/receipt')}`;
	if (cartAbandonmentEmail) paymentData.cartAbandonmentEmail = true;
	else paymentData.cartAbandonmentEmail = false;

	if (paymentData.address.state && !countries[paymentData.address.country].states) delete paymentData.address.state;
	if (typeof paymentData.address.identityNumber !== 'undefined') delete paymentData.address.identityNumber;
	if (useShippingAddress && paymentData.shippingAddress.state && !countries[paymentData.shippingAddress.country].states) delete paymentData.shippingAddress.state;
	delete paymentData.termsAndConditions;

	let additionalNotes = '';
	if (paymentData.additionalInformation) {
		additionalNotes = paymentData.additionalInformation.map((info) => info?.message).join('\n');
		delete paymentData.additionalInformation;
	}
	if (additionalNotes) paymentData.additionalNotes = additionalNotes;

	if (!useShippingAddress) {
		paymentData = Object.keys(paymentData).filter((data) => data !== 'shippingAddress').reduce((acc, data) => ({ ...acc, [data]: paymentData[data] }), {});
	}

	if (window.CentraCheckout) {
		window.CentraCheckout.suspend();
	}

	return fetchCheckout('/payment-fields', token, paymentData, 'PUT').then((data) => {
		dispatch({ type: UPDATE_SELECTION, data });
		return dispatch({ type: PAYMENT_RETURN, data });
	}).catch((err) => console.log('DEBUG: err', err));
};

export const clearKlarna = () => ({ type: PAYMENT_RETURN });

export const enrichProducts = (params) => ({ type: ENRICH_PRODUCTS, ...params });

export const purchase = () => (dispatch, getState) => {
	const { token, paymentFields } = getState().checkout.selection;
	const { setup } = getState().environment;
	const { country, language, countries } = setup;
	let paymentData = deepClone(getState().checkout.payment);
	let hasErrors = false;

	const useShippingAddress = getState().checkout.useShippingAddress;
	paymentData.address.country = paymentData.address.country || country;
	paymentData.paymentFailedPage = `${window.location.origin}${prefix(setup, 'selection/failed')}`;
	paymentData.paymentReturnPage = `${window.location.origin}${prefix(setup, 'selection/receipt')}`;

	// Check for errors.
	Object.keys(paymentFields).forEach((firstLevel) => {
		if (firstLevel === 'address' || (firstLevel === 'shippingAddress' && useShippingAddress)) {
			Object.keys(paymentFields[firstLevel]).forEach((secondLevel) => {
				const field = firstLevel === 'shippingAddress' ? paymentFields.address[secondLevel] : paymentFields[firstLevel][secondLevel];

				if (field.visible && field.required) {
					// We should have a value. Is it correct?
					const fieldType = secondLevel === 'email' ? 'email' : 'text';
					const error = fieldValidation(paymentData[firstLevel][secondLevel], fieldType);
					if (error) {
						dispatch({ type: UPDATE_ERRORS, group: firstLevel, id: secondLevel, error });
						hasErrors = true;
					}
				}
			});
		} else if (firstLevel !== 'shippingAddress') {
			const field = paymentFields[firstLevel];

			if (field.visible && field.required) {
				// We should have a value. Is it correct?
				const error = fieldValidation(paymentData[firstLevel], 'text');
				if (error) {
					dispatch({ type: UPDATE_ERRORS, id: firstLevel, error });
					hasErrors = true;
				}
			}
		}
	});

	if (hasErrors) return dispatch({ type: SELECTION_ERROR, hasError: true });

	if (!useShippingAddress) {
		paymentData = Object.keys(paymentData).filter((data) => data !== 'shippingAddress').reduce((acc, data) => ({ ...acc, [data]: paymentData[data] }), {});
	}

	if (paymentData.address.state && !countries[paymentData.address.country].states) delete paymentData.address.state;
	if (useShippingAddress && paymentData.shippingAddress.state && !countries[paymentData.shippingAddress.country].states) delete paymentData.shippingAddress.state;

	let additionalNotes = '';
	if (paymentData.additionalInformation) {
		additionalNotes = paymentData.additionalInformation.map((info) => info?.message).join('\n');
		delete paymentData.additionalInformation;
	}
	if (additionalNotes) paymentData.additionalNotes = additionalNotes;

	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	window.dataLayer.push({
		event: 'SubmitCheckout',
		values: { ...paymentFields.address },
	});

	return fetchCheckout('/payment', token, paymentData, 'POST').then((data) => {
		if (data.action === 'redirect') {
			// Redirect to new URL
			window.location = data.url;
			return false;
		}
		if (data.action === 'form') {
			// Return to checkout to display form
			const d = document.createElement('div');
			d.innerHTML = data.formHtml;
			document.body.appendChild(d);
			d.querySelector('form').submit();
			return false;
		}
		if (data.action === 'success') {
			// Purchase complete navigate to receipt.
			return dispatch({ type: 'RECEIPT', payload: { language } });
		}
		if (data.errors && data.errors.stock) {
			dispatch({ type: UPDATE_SELECTION, data });
			return dispatch({ type: SELECTION_ERROR_STOCK, hasError: true });
		}
		return dispatch({ type: SELECTION_ERROR, hasError: true });
	}).catch((err) => console.log('DEBUG: err', err));
};

export const destroySelection = () => (dispatch, getState) => {
	const { country, countries } = getState().environment.setup;
	const defaultCountrySettings = countries[country];
	// Clear possible campaign market/pricelist to keep in sync with Centra.
	dispatch({ type: 'UPDATE_COUNTRY', country, market: parseInt(defaultCountrySettings.market, 10), pricelist: parseInt(defaultCountrySettings.pricelist, 10) });
	dispatch({ type: 'RETRIEVE_PRODUCT_CACHE' });

	dispatch({ type: DESTROY_SELECTION });
};
